import { ErrorBoundary } from '@/pages/automations/workflows/layout/error';

export default ErrorBoundary;
